'use strict';
import LightBox from "./components/LightBox.js";

__webpack_public_path__ = document.currentScript.src.replace(/\/scripts\/[^\/]+$/, '/');
import '../styles/front.scss';
import 'swiper/css/bundle';
import { Donation } from './shortcodes/Donation.js';
import { Form } from './helpers/Form.js';
import CreateACampaignForm from "./components/CreateACampaignForm.js";
import Modals from "./components/Modals.js";

// import { SignUpForm } from './components/SignUpForm.js';
import { Checkout } from './components/Checkout.js';
import { Header } from './components/Header.js';
import { Datatables } from "./components/Datatables.js";
import { Helper } from "./helpers/Helper.js";
import { MultiStepForms } from './components/MultiStepForm/MultiStepForms.js';
import { CopyToClipboard } from "./components/CopyToClipboard.js";
import { MyAccount } from "./components/MyAccount.js";
import { Ajax } from "./helpers/Ajax.js";
import Confetti from "./components/Confetti.js";
import { MonthlyGiving } from "./components/MonthlyGiving.js";
import { DonationsForm } from "./components/DonationsForm.js";
import { DonationOrderMetabox } from "./metaboxes/DonationOrderMetabox.js";
import {Tooltip} from "./components/Tooltip.js";
import DatePicker from "./components/DatePicker.js";
import MyAccountEdit from "./components/MyAccountEdit.js";
import { CopyText } from "./components/CopyText.js";
import FilterableCardsList from "./components/FilterableCardsList.js";
import { DonationVariation } from "./components/DonationVariation.js";
import GatewayTabs from "./components/GatewayTabs.js";
import Slider from "./components/Slider.js";
import Slider2 from "./components/Slider2.js";
import {ChoiceSelect} from "./components/ChoiceSelect.js";
import { SearchCampaignsProperly } from "./shortcodes/SearchCampaignsProperly.js";
import {DonationShortcode} from "./components/DonationShortcode.js";
import {AdminActions} from "./components/AdminActions.js";
import {WebsocketConnection} from "./websocket/WebsocketConnection.js"
import {init_cf_search_dropdown_custom_fields} from "./utils/CustomFields.js";
import {DonationAmount} from "./components/DonationAmount.js";
import {DonationFrequency} from "./components/DonationFrequency.js";
import { DonationTribute } from "./components/DonationTribute.js";
import { DonationMultipleRecipients } from "./components/DonationMultipleRecipients.js";
import "./components/GiftAid.js";
import "./components/AdditionalFees.js";
import "./components/AnonymousDonation.js";
import "./components/CcFee.js";
import "./components/CharitableFoundation.js";
import "./components/IgulLtova.js";
import "./components/OrganizationDonation.js";
import DonationTypeDropdown from "./components/DonationTypeDropdown.js";
import "./components/UserCountry.js";
import {PhoneNumberField} from "./components/PhoneNumberField.js";
import {ImageZoomer} from "./components/ImageZoomer.js";
import {SignatureField} from "./components/SignatureField.js";
import {MyAccountStats} from "./components/MyAccountStats.js";
import {MyAccountGamificationParticipantDashboard} from "./components/MyAccountGamificationParticipantDashboard.js";
import {MyAccountGamificationMyCampaign} from "./components/MyAccountGamificationMyCampaign.js";
import {GamificationMyAccountCampaignEdit} from "./components/GamificationMyAccountCampaignEdit.js";
import { TeamCampaignEdit } from './components/TeamCampaignEdit.js';
import { CampaignMessageMediaUpload } from './components/CampaignMessageMediaUpload.js';
import { Toast } from "./helpers/Toast.js";

// Expose toast for all notifications (my-account, modals, etc.)
if (typeof window !== 'undefined') {
	window.levToast = Toast;
}

document.addEventListener( 'DOMContentLoaded', () => {
	const helper = new Helper();
	helper.disableNumberInputScroll();
	helper.setTimezoneOffset();
	//helper.setUserCountryCode();

	new Ajax().handlers();

	new AdminActions();
	new Datatables();
	new Donation();
	new Checkout();
	new Header();
	new MyAccount();
	new MonthlyGiving();
	new DonationOrderMetabox();
	new CopyText();
	new DonationVariation();
	new DonationTribute();
	new DonationMultipleRecipients();
	new DonationTypeDropdown();
	new SearchCampaignsProperly();
	new DonationShortcode();
	// Dynamically import QrCodeGenerator only if the button exists
	if (document.getElementById("generateQRButton")) {
		import(/* webpackChunkName: "qrcode-generator" */ "./components/QrCodeGenerator.js").then(({QrCodeGenerator}) => {
			new QrCodeGenerator();
		});
	}
	new ImageZoomer();
	new MyAccountStats();
	new MyAccountGamificationParticipantDashboard();
	new MyAccountGamificationMyCampaign();
	new GamificationMyAccountCampaignEdit();
	new TeamCampaignEdit();
	new CampaignMessageMediaUpload();
	new Modals();
	new PhoneNumberField();
	// new SignUpForm();

	const donationsForm = new DonationsForm();
	donationsForm.watchOtherAmountToggle();
	donationsForm.watchVariationsChange();

	window.levcharityMultiStepForms = new MultiStepForms();

	const form = new Form();
	form.watchCheckboxes();
	form.addCampaignToCart();

	const createCampaignForm = new CreateACampaignForm();
    createCampaignForm.init();

	const copyToClipboard = new CopyToClipboard();
	copyToClipboard.init('.copy_to_clipboard_button');


	if (document.body.classList.contains('levcharity-confetti')) {
		const confetti = new Confetti(300, 4000, false);
		confetti.initialize();
	}

	new Tooltip();
	new DatePicker();

	new MyAccountEdit();
	new DonationAmount();
	new DonationFrequency();

	GatewayTabs();

	const choiceSelect = new ChoiceSelect();
	choiceSelect.singleSelect();
	choiceSelect.singleInput();
	choiceSelect.multiSelect( '.multi_choices_select select');

	new Slider();
	new Slider2();

	new LightBox();

	if(websocketEnabled && websocketEnabled[0] === 'on'){
			new WebsocketConnection();
	}
	init_cf_search_dropdown_custom_fields()

	document.querySelectorAll('.wp-block-custom-products-archive-list-levit-block .products_archive_wrapper:not(.p2p-campaign)')?.forEach(wrapper => {
		const campaignsList = new FilterableCardsList(wrapper);

		campaignsList.generateCampaignsArray();
		campaignsList.initialize();
	})

	new SignatureField();
} );
